
import { CurrencyPipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalService } from '../../_global/global.service';
import { UtilService } from '../../_global/util.service';
import { BranchsService } from '../../_services/branch/branchs.service';
import { DashboardService } from '../../_services/dashboard/dashboard.service';
import { ReportsService, RateService, CompanyService } from '../../_services/index';
import { PartnerCommissionService } from '../../_services/raterule/PartnerCommission.service';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";


declare var $: any;

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-wrapper",
    templateUrl: "./loaderPage.component.html",
    providers: [RateService, ReportsService, CompanyService, PartnerCommissionService, BranchsService, DashboardService, CurrencyPipe],
    encapsulation: ViewEncapsulation.None
})
export class LoaderPageComponent implements OnInit {


    loading = true;



    constructor(
        private _util: UtilService,
        private _reportsService: ReportsService,
        public _gs: GlobalService,
        public _router: Router,
        private partnerCommissionService: PartnerCommissionService,
        private _branchsService: BranchsService,
        private _DashboardService: DashboardService,
        private _rateService: RateService,
        private currencyPipe: CurrencyPipe,
        private companyService: CompanyService,
        private ng4LoadingSpinnerService: Ng4LoadingSpinnerService,

    ) {


    }


    ngOnInit() {
        this.loader();
    }
    loader() {
        this.loading = true;
        this.ng4LoadingSpinnerService.show();


    }












}



// WEBPACK FOOTER //
// ./src/app/auth/loaderPage/loaderPage.component.ts